"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILBackground = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var background_enum_1 = require("../../shared/enums/background.enum");
var brand_config_1 = require("../../configs/brand.config");
var getBackground = function (bg) {
    if (bg === void 0) { bg = background_enum_1.BackgroundEnum.MONARCH; }
    return brand_config_1.brandConfig[bg].background;
};
var ILBackground = function (props) {
    // defaults
    props = {
        sx: __assign({ backgroundColor: 'background.paper', width: '100%', height: '100%', position: 'absolute', overflow: 'hidden', top: 0, zIndex: -1 }, props.sx),
        childSx: __assign(__assign({ width: '100%', height: '100%', backgroundColor: 'primary.main', backgroundSize: 'contain', position: 'absolute' }, props.childSx), { 
            // can't be overriden
            backgroundImage: "url(".concat(getBackground(props.background), ")") }),
    };
    return (react_1.default.createElement(material_1.Box, { sx: props.sx, "data-testid": "il-background" },
        react_1.default.createElement(material_1.Box, { sx: props.childSx, "data-testid": props.background })));
};
exports.ILBackground = ILBackground;
